import Skeleton from '../ui/Skeleton';
import Button from '../ui/Button';

export default function PhoneLoadingScreen({ title = 'Getting Vylo ready', subtitle, onRetry }) {
  return <div role="status" aria-label={title} aria-busy={!onRetry} className="min-h-screen bg-[var(--color-bg)] px-5 py-6">
    {onRetry ? <div className="mx-auto max-w-sm py-16 text-center"><p className="text-lg font-semibold">{title}</p>
      {subtitle ? <p className="mt-3 text-sm text-[var(--color-text-muted)]">{subtitle}</p> : null}
      <Button onClick={onRetry} className="mt-5">Try again</Button></div>
      : <div aria-hidden="true" className="mx-auto max-w-[600px]"><Skeleton.MobileDashboard /></div>}
  </div>;
}
